import { Injectable, NgZone } from "@angular/core";
import { Subject } from "rxjs";
import { SessionProvider } from "../session/session";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppDetectorProvider } from "../detector/detector";
import { environment } from "src/environments/environment";

declare var BackgroundGeolocation, Location;

@Injectable({providedIn:'root'})
export class GeolocationService {
  isTracking: boolean = false;
  activeId: number = -1;
  mode: TrackingMode = TrackingMode.spectatorInvisible;
  onLocationSub = new Subject<any>();

  constructor(
    private sessionService: SessionProvider,
    private httpClient: HttpClient,
    private appDetector: AppDetectorProvider,
    private ngZone: NgZone
  ) { }

  setupPlugin(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!this.appDetector.isHannoverApp() || this.isTracking) {
        resolve(true);
        return;
      }

      console.log('setupPlugin() inside...');
      BackgroundGeolocation.onLocation(this.onLocation.bind(this));
      BackgroundGeolocation.ready({
        debug: false,
        logLevel: BackgroundGeolocation.LOG_LEVEL_OFF,
        // Geolocation config
        desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,  // <-- highest possible accuracy
        distanceFilter: 0,            // Must be 0 or locationUpdateInterval is ignored!
        locationUpdateInterval: 2000,  // Get a location every 5 seconds
        stopTimeout: 1,
        reset: true,
        // Application config
        stopOnTerminate: true,
        startOnBoot: true,
        heartbeatInterval: 60,
        disableElasticity: true,
        // [Android] backgroundPermissionRationale for Always permission.
        backgroundPermissionRationale: {
          title: "Ermöglichen Sie {applicationName}, auf den Speicherort dieses Geräts zuzugreifen, auch wenn es geschlossen ist oder nicht verwendet wird.",
          message: "Diese App verarbeitet Standortdaten, um das GPS Tracking zu ermöglichen.",
          positiveAction: 'Wechseln Sie zu "{backgroundPermissionOptionLabel}"',
          negativeAction: 'Abbrechen'
        }
      }, (state) => {
        this.ngZone.run(() => {
          // Set current plugin state upon our view.
          BackgroundGeolocation.start(() => {
            this.isTracking = true;
            console.log('g-1');
            resolve(true);
            BackgroundGeolocation.changePace(true, () => {
              console.log('[Geolocation Service]::INFO, The plugin has started...');
              this.isTracking = true;
              resolve(true);
            }, (err) => {
              console.log('[Geolocation Service]::ERROR, changePace(): ' + err);
              this.isTracking = false;
              reject(false);
            });
          });
        });
      }).catch(err => {
        console.log('[Geolocation Service]::ERROR, setupPlugin(): ' + err);
        this.isTracking = false;
        reject(false)
      });
    });
  }

  stopPlugin() {
    if (this.isTracking) {
      BackgroundGeolocation.stop();
      BackgroundGeolocation.reset();
      this.isTracking = false;
      this.removePos();
      console.log('the plugin has stopped...');
    }
  }

  onLocation(location: Location) {
    this.ngZone.run(() => {
      if (this.isTracking) {
        this.onLocationSub.next(location);
        if (navigator.onLine)
          this.sendPosition(location);
      }
    })
  }

  removePos() {
    console.log('[INFO] removePos()...');
    if (!navigator.onLine) return;

    this.sessionService.getToken(false, false).then(token => {
      let url = `${environment.routeApi}user/${token}/location/delete`;
      this.httpClient.post(url, null).subscribe(() => {
      });
    }, (err) => {
      console.log('[HTTP remove pos] - failuer, ' + JSON.stringify(err));
    });
  }


  private async sendPosition(location: any) {
    console.log('[INFO] sendPosition()...');
    if (!navigator.onLine) return;

    if (this.mode != TrackingMode.spectatorInvisible) {
      if (!this.sessionService.isLoged) return;
      this.sessionService.getToken(false, false).then(token => {
        let url = "https://spooorts.de/revt/itms/savepos?token=" + token + '&eventId=' + this.activeId;
        let body = [
          {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude
          }
        ];
        console.log('INSIDE...')
        if (!navigator.onLine) return;

        console.log('INSIDE2...')
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', "application/json");
        this.httpClient.post(url, body, {
          headers: headers
        }).toPromise().then((res) => {
        }, (err) => {
          console.log('[HTTP-send-pos]: failure, ' + JSON.stringify(err));
        });
      });
    }
  }

  onRequestLocation() {
    return this.onLocationSub;
  }
}




export enum TrackingMode {
  spectatorInvisible,
  spectatorVisible,
  participant
}